export default __webpack_public_path__ + "static/media/359.3a3a09a4.jpg";